import { Campaign } from '../../types';
import { getLastGameResult } from './is-campaign-available';
import { timeDifferenceRu, timeDifference } from './time-difference';

export const getDisabledCampaignText = (textTemplate: string, campaign?: Campaign) => {
  const lastGameResult = getLastGameResult(campaign?.id);

  if (!lastGameResult) {
    return textTemplate;
  }

  const now = Date.now();
  const breakMs = (campaign?.widgetBreakDuration || 0) * 60 * 60 * 1000;
  const availableAfter = lastGameResult.timestamp + breakMs;
  const isEng = Boolean(campaign?.wixInstanceId);
  const timeDifferenceFn = isEng ? timeDifference : timeDifferenceRu;

  if (availableAfter < now) {
    return textTemplate.replace(/%time%/g, isEng ? '0\xa0hours' : '0\xa0часов');
  }

  const diff = timeDifferenceFn(new Date(availableAfter), new Date(now));

  return textTemplate.replace(/%time%/g, diff);
};
